// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__tMxAX","title":"Header_title__djEJ9","side":"Header_side__1-9tY"};